import commonMessage from "../../constant/commonMessage";
import { validatePassword } from "../../utils/regexValidatorHelper";

const {
  OLD_PASSWORD_REQUIRED,
  NEW_PASSWORD_REQUIRED,
  CONFIRM_PASSWORD_REQUIRED,
  CONFIRM_PASSWORD_MATCH,
  INVALID_PASSWORD,
  FIRST_NAME_REQUIRED,
} = commonMessage;

export const userProfile = {
  //Change User Password Schema
  changeUserPasswordSchema: {
    oldPassword: {
      required: true,
      message: OLD_PASSWORD_REQUIRED,
    },
    newPassword: {
      required: true,
      message: NEW_PASSWORD_REQUIRED,
      validate: (value, inputData = {}) => {
        return validatePassword(value);
      },
      invalidMessage: INVALID_PASSWORD,
      extraMessage: true,
    },
    confirmPassword: {
      required: true,
      message: CONFIRM_PASSWORD_REQUIRED,
      validate: (value, inputData = {}) => {

        if (inputData?.confirmPassword !== inputData?.newPassword) {
          return false;
        } else {
          return validatePassword(value);
        }
      },
      invalidMessage: CONFIRM_PASSWORD_MATCH,
      extraMessage: true,
    },
  },

  // Update User Profile
  updateProfieSchema: {
    firstName: {
      required: true,
      message: FIRST_NAME_REQUIRED,
    },
  },
};
